/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_YoursInputs */

const th_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ของคุณ`)
};

const en_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yours`)
};

const ja_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分のミーティング`)
};

const zh_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的`)
};

const es_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuyas`)
};

const pt_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas`)
};

const id_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milik Anda`)
};

const fr_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les vôtres`)
};

const tl_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa iyo`)
};

const vi_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Của bạn`)
};

const ko_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 회의`)
};

const de_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine`)
};

const ru_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши`)
};

const tr_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizinkiler`)
};

const it_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue`)
};

const pl_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje`)
};

const uk_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші`)
};

const hi_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी`)
};

const ar_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجتماعاتك`)
};

const ms_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milik anda`)
};

const bn_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার`)
};

const zh_tw2_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的`)
};

const zh_hk2_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的`)
};

const ur_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کی`)
};

const fa_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`از آنِ شما`)
};

const sw_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yako`)
};

const nl_meeting_yours = /** @type {(inputs: Meeting_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Van jou`)
};

/**
* | output |
* | --- |
* | "Yours" |
*
* @param {Meeting_YoursInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_yours = /** @type {((inputs?: Meeting_YoursInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_YoursInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_yours(inputs)
	if (locale === "ja") return ja_meeting_yours(inputs)
	if (locale === "zh") return zh_meeting_yours(inputs)
	if (locale === "es") return es_meeting_yours(inputs)
	if (locale === "pt") return pt_meeting_yours(inputs)
	if (locale === "id") return id_meeting_yours(inputs)
	if (locale === "fr") return fr_meeting_yours(inputs)
	if (locale === "tl") return tl_meeting_yours(inputs)
	if (locale === "vi") return vi_meeting_yours(inputs)
	if (locale === "ko") return ko_meeting_yours(inputs)
	if (locale === "de") return de_meeting_yours(inputs)
	if (locale === "ru") return ru_meeting_yours(inputs)
	if (locale === "tr") return tr_meeting_yours(inputs)
	if (locale === "it") return it_meeting_yours(inputs)
	if (locale === "pl") return pl_meeting_yours(inputs)
	if (locale === "uk") return uk_meeting_yours(inputs)
	if (locale === "hi") return hi_meeting_yours(inputs)
	if (locale === "ar") return ar_meeting_yours(inputs)
	if (locale === "ms") return ms_meeting_yours(inputs)
	if (locale === "bn") return bn_meeting_yours(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_yours(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_yours(inputs)
	if (locale === "ur") return ur_meeting_yours(inputs)
	if (locale === "fa") return fa_meeting_yours(inputs)
	if (locale === "sw") return sw_meeting_yours(inputs)
	if (locale === "nl") return nl_meeting_yours(inputs)
	return en_meeting_yours(inputs)
});